import * as $ from 'jquery';

function handleError($field, message)
{
    // Fallback for selectpicker
    var $container = $field,
        $closestContainer = $field.closest('div.form-control');

    if ($closestContainer.length > 0) $container = $closestContainer;

    $container.addClass('is-invalid');
    $container.after( $('<div class="invalid-feedback">').html(message) );

    $container.one('click', function(e) {
        $container.next('div.invalid-feedback').remove();
        $container.removeClass('is-invalid');
    });
}

function createHiddenField(name, value)
{
    var $input = $('<input type="hidden">');
    $input.prop('name', name);
    $input.val(value);

    return $input;
}

export default (
    function()
    {
        $('.edition-date-table').each(function() {
            var $table = $(this);

            $table.find('.edition-date-add').on('click', function(e) {
                e.preventDefault();

                $table.on('click', 'button.edition-del-btn', function(e) {
                    e.preventDefault();
                    $(this).closest('tr').remove();
                });

                var $date = $table.find('[name=edition_date_date]'),
                    $location = $table.find('[name=edition_date_location]'),
                    $trainer = $table.find('[name=edition_date_trainer]'),
                    $co_trainer = $table.find('[name=edition_date_cotrainer]'),
                    row_count = $table.find('tbody > tr').length;

                // Validate
                var has_errors = false;
                if ($date.val() == '')
                {
                    handleError($date, 'This field is required');
                    has_errors = true;
                }
                if ($location.val() == '')
                {
                    handleError($location, 'This field is required');
                    has_errors = true;
                }
                if ($trainer.val() == '')
                {
                    handleError($trainer, 'This field is required');
                    has_errors = true;
                }

                if (!has_errors)
                {
                    var data = {
                        date: $date.val(),
                        location_id: $location.val(),
                        trainer_id: $trainer.val(),
                        co_trainer_id: $co_trainer.val()
                    };

                    var labels = {
                        location_id: $location.find('option:selected').text(),
                        trainer_id: $trainer.find('option:selected').text(),
                        co_trainer_id: ($co_trainer.val()) ? $co_trainer.find('option:selected').text() : ''
                    };

                    var $row = $('<tr>'),
                        baseFieldName = 'newSessions[' + row_count + ']';

                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[date_start]', data.date) ).append(data.date) );
                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[location_id]', data.location_id) ).append(labels.location_id) );
                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[trainer_id]', data.trainer_id) ).append(labels.trainer_id) );
                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[co_trainer_id]', data.co_trainer_id) ).append(labels.co_trainer_id) );

                    var $delButton = $('<button class="btn btn-secondary edition-del-btn">').html('<i class="fa fa-trash-o">')

                    $row.append( $('<td>').append( $delButton ) );

                    $table.find('tbody').append($row);
                }

            });

        });
    }($)
);